// src/components/MobileFooterSpacer.js
import styled from "styled-components";

const MobileFooterSpacer = styled.div`
  display: none;

  /* Only show in Capacitor native app */
  body.capacitor & {
    @media (max-width: 768px) {
      display: block;
      height: 105px; /* Space for the fixed footer */
    }
  }
`;

export default MobileFooterSpacer;